import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/customer',
    params: params,
  })

  return response?.data
}

export const getExternal = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/customer/external',
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/customer',
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/customer/${id}`,
    data,
  })

  return response?.data
}

export const deleteSingle = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/customer/${id}`,
  })

  return response?.data
}

export const deleteMany = async (ids) => {
  const responses = await Promise.map(ids.map((id) => deleteSingle(id)))

  return responses.map((response) => response?.data)
}
